/**
 * Feel free to re-do this component! It's a quick and dirty port from Dewo SDK,
 * needed for the new memory options modal. No final design exists at this time.
 * @link https://www.figma.com/file/COpC4br45YO16rA285ycIB/Timely-UI-kit-(Cibola-%E2%80%A2-Timely-Design-System)?type=design&node-id=295-3581&mode=design&t=shwPLNuwRv3NCLaw-4
 */

import classNames from 'classnames';
import React from 'react';
import type { ElementProps } from '../element/Element';
import { Element } from '../element/Element';
import styles from './Tabs.module.scss';

interface TabsProps extends ElementProps {}

function Container(props: TabsProps) {
  return <Element as="ul" {...props} className={classNames(styles.container, props.className)} />;
}

interface TabItemProps extends TabsProps {
  active?: boolean;
  disabled?: boolean;
}
function Item(props: TabItemProps) {
  const { className, active, disabled, ...finalProps } = props;
  return (
    <Element
      as="li"
      {...finalProps}
      className={classNames(
        styles.item,
        { [styles.active]: active, [styles.disabled]: disabled },
        className
      )}
    />
  );
}

/**
 * Quick & dirty tabs component
 * @todo Awaiting finalization via https://www.figma.com/file/COpC4br45YO16rA285ycIB/Timely-UI-kit-(Cibola-%E2%80%A2-Timely-Design-System)?type=design&node-id=295-3581&mode=design&t=shwPLNuwRv3NCLaw-4
 */
export const Tabs = Object.assign(Container, {
  Item,
});
